import React from 'react';
import { useAuth } from '../context/AuthContext';
import { FiLogOut } from 'react-icons/fi';

export default function UserBadge() {
  const { user, signOut } = useAuth();
  if (!user) return null;

  const avatar =
    user.photoURL ||
    `https://ui-avatars.com/api/?name=${encodeURIComponent(user.displayName || 'U')}&background=0052cc&color=fff&size=128`;

  return (
    <div className="user-badge">
      <img src={avatar} alt={user.displayName} className="user-avatar" referrerPolicy="no-referrer" />
      <span className="user-name">{user.displayName}</span>
      <button className="signout-btn" onClick={signOut} title="Sign out">
        <FiLogOut />
      </button>
    </div>
  );
}
